module.exports = __webpack_public_path__ + "static/media/logo-ltrent-l-test.72774e30.png";